import React from 'react';
import { IItemForGetShortInfo } from 'types';
import { Checkbox } from 'antd';
import Text from 'components/Text/Text';
import { RestaurantMultipleSelect } from './RestaurantMultipleSelect';
import style from './index.module.scss';

interface IProps {
	setAdditionalRestaurants: (value: string[]) => void;
	toggleApplyToOne: (value: boolean) => void;
	selectedAdditionalRestaurants: string[];
	isApplyToOne: boolean;
	fetchedRestaurants: IItemForGetShortInfo[];
	IDSelectedRestaurant: Nullable<string>;
}

export const RestaurantsBlock: React.FC<IProps> = React.memo(
	({
		setAdditionalRestaurants,
		toggleApplyToOne,
		selectedAdditionalRestaurants,
		isApplyToOne,
		fetchedRestaurants,
		IDSelectedRestaurant,
	}) => {
		const handleToggleApplyToOne = () => {
			toggleApplyToOne(!isApplyToOne);
			setAdditionalRestaurants([]);
		};

		return (
			<div className={style.container}>
				<div className={style.fieldWrapper}>
					<Text
						className={style.heading}
						translationNameSpace="form"
						translationKey="changesAppliesHeading"
						theme="secondary"
						size="l"
						weight="bold"
					/>
					<Checkbox className={style.checkBox} checked={isApplyToOne} onChange={handleToggleApplyToOne}>
						<Text
							translationNameSpace="form"
							translationKey="changesAppliesToRestaurantLabel"
							asFragment={true}
						/>
					</Checkbox>
				</div>
				<div className={style.fieldWrapper}>
					<div className={style.heading}>
						<Text
							translationNameSpace="form"
							translationKey="restaurantsHeading"
							theme="secondary"
							size="l"
							weight="bold"
						/>
						<Text
							className={style.hint}
							translationNameSpace="form"
							translationKey="restaurantSelectHint"
							theme="secondaryLight"
							size="s"
							weight="bold"
						/>
					</div>
					<Text
						translationNameSpace="form"
						translationKey="descriptionForFinishPortionCreation"
						theme="neutralLight"
						size="s"
					/>
					<RestaurantMultipleSelect
						setAdditionalRestaurants={setAdditionalRestaurants}
						selectedAdditionalRestaurants={selectedAdditionalRestaurants}
						isApplyToOne={isApplyToOne}
						fetchedRestaurants={fetchedRestaurants}
						IDSelectedRestaurant={IDSelectedRestaurant}
					/>
				</div>
			</div>
		);
	},
);
